/** @format */

import React from "react";

type subtitleProps = {
  summary: String;
};
const Subtitle = ({ summary }: subtitleProps) => {
  return (
    <p className="md:w-[484px] lg:px-0 md:px-20 px-10 m-auto text-center font-normal text-[20px] leading-[27px] tracking-[-0.02em] md:mt-0 mt-10">
      {summary}
    </p>
  );
};

export default Subtitle;
